module.exports = __webpack_public_path__ + "media/product/latest-ddeal-2-064ad840.png";